module.exports = __webpack_public_path__ + "static/teachr-cover-1c24a21cd0e2a318ff97dfab5f37e33c.png";